import { shipmentListUrlFilters, shipmentListUrlFiltersEnum, shipmentListUrlQueryParams } from "@saleor/shipment/urls";
import {  ShipmentFilterInput } from "@saleor/types/globalTypes";
import { createFilterTabUtils, createFilterUtils,  } from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "shipmentFilters";

export const {
    deleteFilterTab,
    getFilterTabs,
    saveFilterTab
  } = createFilterTabUtils<shipmentListUrlFilters>(ATTRIBUTE_FILTERS_KEY);
  
export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
    shipmentListUrlQueryParams,
    shipmentListUrlFilters
>(shipmentListUrlFiltersEnum);


export function getFilterVariables(
    params: shipmentListUrlFilters
  ): ShipmentFilterInput {
    return {
      search: params.query,
    };
}